import * as React from 'react';

import PropTypes from 'prop-types';

import Icon from 'bundles/iconfont/Icon';

class SaveLink extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    text: PropTypes.string.isRequired,
    updating: PropTypes.bool,
  };

  static defaultProps = {
    className: 'settings-primary-action',
  };

  onClick(ev: $TSFixMe) {
    ev.preventDefault();
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'onClick' does not exist on type 'Readonl... Remove this comment to see the full error message
    this.props.onClick();
  }

  render() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'className' does not exist on type 'Reado... Remove this comment to see the full error message
    const { className, text, updating } = this.props;

    return (
      <button className={className + ' button-link'} onClick={(ev) => this.onClick(ev)}>
        {updating ? <Icon name="circle-o-notch" spin={true} /> : text}
      </button>
    );
  }
}

export default SaveLink;
